
export default {
  name: 'PaginationCommon',
  // eslint-disable-next-line vue/require-prop-types
  props: ['currentPage', 'lastPage'],
  data() {
    return {
      maxContent: 3
    }
  },
  computed: {
    minPage() {
      if (this.lastPage <= this.maxContent * 2) {
        return 1
      }
      if (this.maxContent + this.currentPage > this.lastPage) {
        return this.lastPage - this.maxContent * 2
      }

      if (this.currentPage - this.maxContent > 1) {
        return this.currentPage - this.maxContent
      }

      return 1
    },
    maxPage() {
      if (this.lastPage <= this.maxContent * 2 + 1) {
        return this.lastPage
      }
      if (this.currentPage <= this.maxContent) {
        return this.maxContent * 2 + 2
      }
      if (this.maxContent + this.currentPage <= this.lastPage) {
        return this.maxContent + this.currentPage + 1
      }
      return this.lastPage
    },
    listPage() {
      const data = []
      for (let x = this.minPage; x <= this.maxPage; x++) {
        data.push(x)
      }
      return data
    }
  },
  methods: {
    changePage(page) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('change', page)
    },
    prePage() {
      if (this.currentPage >= 2) {
        this.changePage(this.currentPage - 1)
      }
    },
    nextPage() {
      if (this.currentPage <= this.lastPage - 1) {
        this.changePage(this.currentPage + 1)
      }
    }
  }
}
